import { exists, SystemCodeArea, SystemCodeAddress } from '@/api'

export interface BatchStatisticsRegUsrConditionListItem {
  registDateFrom: string
  registDateTo: string
  registTitle: string
  lastLendDateFrom: string
  lastLendDateTo: string
  registBranchCodeFrom: string
  registBranchCodeTo: string
  areaCodeFrom: SystemCodeArea
  areaCodeTo: SystemCodeArea
  addressCodeForm: SystemCodeAddress
  addressCodeTo: SystemCodeAddress
  yearAgeEnabled: boolean
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  isOutputFull: boolean
  registMemo: string
  batchType: string
}

export function BatchStatisticsRegUsrConditionListItemFromJSON(
  json: any
): BatchStatisticsRegUsrConditionListItem {
  const resp = JSON.parse(json)

  return {
    registDateFrom: exists(resp, 'regist_date_from')
      ? resp.regist_date_from
      : '',
    registDateTo: exists(resp, 'regist_date_to') ? resp.regist_date_to : '',
    lastLendDateFrom: exists(resp, 'last_lend_date_from')
      ? resp.last_lend_date_from
      : '',
    lastLendDateTo: exists(resp, 'last_lend_date_to')
      ? resp.last_lend_date_to
      : '',
    registTitle: exists(resp, 'title') ? resp.title : '',
    registBranchCodeFrom: exists(resp, 'regist_branch_code_from')
      ? resp.regist_branch_code_from
      : '',
    registBranchCodeTo: exists(resp, 'regist_branch_code_to')
      ? resp.regist_branch_code_to
      : '',
    areaCodeFrom:
      exists(resp, 'area_code_from') && resp.area_code_from !== ''
        ? resp.area_code_from
        : null,
    areaCodeTo:
      exists(resp, 'area_code_to') && resp.area_code_to !== ''
        ? resp.area_code_to
        : null,
    addressCodeForm:
      exists(resp, 'address_code_from') && resp.address_code_from !== ''
        ? resp.address_code_from
        : null,
    addressCodeTo:
      exists(resp, 'address_code_to') && resp.address_code_to !== ''
        ? resp.address_code_to
        : null,
    yearAgeEnabled: exists(resp, 'year_age_enabled')
      ? resp.year_age_enabled
      : false,
    xItem: resp.x_item,
    yItem1: resp.y_item1,
    yCheck1: exists(resp, 'y_check1') ? resp.y_check1 : [false, false],
    yItem2: exists(resp, 'y_item2') ? resp.y_item2 : '',
    yCheck2: exists(resp, 'y_check2') ? resp.y_check2 : [false, false],
    yItem3: exists(resp, 'y_item3') ? resp.y_item3 : '',
    yCheck3: exists(resp, 'y_check3') ? resp.y_check3 : [false, false],
    yItem4: exists(resp, 'y_item4') ? resp.y_item4 : '',
    yCheck4: exists(resp, 'y_check4') ? resp.y_check4 : [false, false],
    isOutputFull: exists(resp, 'is_output_full') ? resp.is_output_full : false,
    registMemo: resp.memo,
    batchType: resp.batch_type
  }
}
